import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AdminNavbar.css";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ContentPasteOutlinedIcon from "@mui/icons-material/ContentPasteOutlined";
import CreateIcon from "@mui/icons-material/Create";

export default function AdminNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedIcon, setSelectedIcon] = useState(null);

  const handleClick = (icon, route) => {
    setSelectedIcon(icon);
    navigate(route);
  };

  useEffect(() => {
    const pathname = location.pathname;
    if (pathname.includes("create-course")) {
      setSelectedIcon("create-course");
    } else if (pathname.includes("course/statistics")) {
      setSelectedIcon("course-students");
    } else if (pathname.includes("admin")) {
      setSelectedIcon("admin");
    } else if (pathname.includes("courses/tasks")) {
      setSelectedIcon("courses/tasks");
    } else if (
      pathname.includes("course/:id/section/:sectionId/lesson/:lessonId/tasks")
    ) {
      setSelectedIcon("courses/tasks");
    }
  }, [location.pathname]);

  const iconStyle = (icon) => ({
    color: selectedIcon === icon ? "#22c75e" : "white",
    borderLeft: selectedIcon === icon ? "4px solid #22c75e" : "none",
  });

  return (
    <div className="admin-navbar">
      <div className="navbar-icons">
        <SchoolOutlinedIcon
          fontSize="large"
          style={iconStyle("admin")}
          sx={{ padding: "10px" }}
          onClick={() => handleClick("admin", "/admin/:id")}
        />
        <CreateIcon
          fontSize="large"
          style={iconStyle("create-course")}
          sx={{ padding: "10px" }}
          onClick={() => handleClick("create-course", "/create-course")}
        />
        <GroupsOutlinedIcon
          fontSize="large"
          style={iconStyle("course-students")}
          onClick={() => handleClick("course-students", "/course/statistics")}
          sx={{ padding: "10px" }}
        />
        <ContentPasteOutlinedIcon
          fontSize="large"
          style={iconStyle("courses/tasks")}
          onClick={() => handleClick("courses/tasks", "/courses/tasks")}
          sx={{ padding: "10px" }}
        />
      </div>
    </div>
  );
}
